import { useLoader } from "@core/hooks/useLoader";
import { loader } from "@phoenix/products/routes/currency.route";

export const useCurrencies = () => {
  const { data, loading } = useLoader<typeof loader>("/currency");
  return {
    current: data,
    loading,
    format: (input?: number, currency?: string) => {
      if (input === undefined) {
        return "";
      }
      const currencyToUse = currency
        ?? data?.Key
        ?? "USD";
      return new Intl.NumberFormat("en-US", { style: "currency", currency: currencyToUse })
        .format(input);
    },
    formatWhole: (input?: number, currency?: string) => {
      if (input === undefined) {
        return "";
      }
      const currencyToUse = currency
        ?? data?.Key
        ?? "USD";
      return new Intl.NumberFormat("en-US", { 
        style: "currency", 
        currency: currencyToUse,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(Math.floor(input));
    }
  }
};

export type UseCurrenciesReturnType = ReturnType<typeof useCurrencies>;
